import { render, staticRenderFns } from "./PerEc.vue?vue&type=template&id=7aed154f&scoped=true"
import script from "./PerEc.vue?vue&type=script&lang=js"
export * from "./PerEc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aed154f",
  null
  
)

export default component.exports